export default {
  LONG_PRESS_THRESHOLD: 400,
  // Edge length in px of the square tiles the tiling lambda produces (aws/planfred-stack/lambdas/perform-pdf-to-tiles-conversion)
  // and the minimum edge length of a location layer source image
  TILE_SIZE: 512,
  LOCAL_STORAGE_PREFIX: 'vuex',
  SHARING_AUTH_TOKEN_QUERY_PARAM: 'sharing-auth-token',
  SEARCH_INDEX_SEPARATOR: ';',
  SIGNATURE_SEPARATOR_COMMENT: '<div>&nbsp;</div><div>&nbsp;</div>',
  FILE_TYPES: {
    ALL: [
      'print',
      'cad',
      'file',
    ],
    PRINT: 'print',
    CAD: 'cad',
    FILE: 'file',
  },
  PLATFORMS: {
    WEB_APP: 'WEB_APP',
    MOBILE_APP_IOS: 'MOBILE_APP_IOS',
    MOBILE_APP_ANDROID: 'MOBILE_APP_ANDROID',
    MOBILE_APP_WEB: 'MOBILE_APP_WEB',
    SERVER: 'SERVER',
  },
  POLLING_APP_STATES: {
    ACTIVE: 'active',
    BLURRED: 'blurred',
    HIDDEN: 'hidden',
  },
  // Load state of a page-owned, polled activities list. LOAD_ERROR vs UPDATE_ERROR is the distinction that
  // matters: LOAD_ERROR means nothing was ever loaded (show the error instead of the list), UPDATE_ERROR means
  // a refresh failed on top of data already shown (keep the list, show the error next to it).
  ACTIVITIES_LOAD_STATE: {
    INITIAL: 'initial',
    LOAD_SUCCESS: 'load_success',
    LOAD_ERROR: 'load_error',
    UPDATE_ERROR: 'update_error',
  },
  TASKS_LIST_GROUPING: {
    GROUP_BY_LOCATION_LAYER: 'location_layer',
    GROUP_BY_TYPE: 'type',
    GROUP_BY_NONE: 'none',
  },
  LOCATION_PIN_CONTENT: {
    NONE: 'none',
    NUMBER: 'number',
    CAMERA_ICON: 'cameraIcon',
    IMAGE: 'image',
  },
  LOCATION_PIN_STATUS: {
    INITIAL: 'initial',
  },
  VALID_PRINT_FILE_EXTENSIONS: [ 'pdf' ],
  VALID_CAD_FILE_EXTENSIONS: [
    'dwg',
    'dxf',
    'dgn',
    'ifc',
    'rvt',
    'pln',
    'vwx',
    'n4d',
    'shx',
  ],
  EXPORT_FILE_FORMATS: {
    XLS: 'xls',
    XLSX: 'xlsx',
    CSV: 'csv',
    VCF: 'vcf',
  },
  DOCUMENT_PERMISSIONS: {
    PUBLIC: 'public',
    RESTRICTED: 'restricted',
  },
  VALID_TASK_STATES: {
    DRAFT: 'draft',
    OPEN: 'open',
    EXECUTION: 'execution',
    QUESTION: 'question',
    DONE: 'done',
  },
  VALID_TASK_DUE_DATE_PRESETS: {
    OVERDUE: 'overdue',
    NOT_SET: 'not_set',
    UPCOMING: 'upcoming',
  },
  VALID_DATE_SHORTCUTS: {
    LAST_WEEK: 'last_week',
    YESTERDAY: 'yesterday',
    TODAY: 'today',
    TOMORROW: 'tomorrow',
    THIS_WEEK: 'this_week',
    NEXT_WEEK: 'next_week',
  },
  VALID_ITEM_APPROVAL_DATE_PRESETS: {
    OVERDUE: 'overdue',
    NOT_SET: 'not_set',
  },
  VALID_ACTIVITY_CATEGORIES: {
    UPLOADS: 'uploads',
    DOWNLOADS: 'downloads',
    SENT: 'sent',
    ACCESS: 'access',
    LOGIN: 'login',
    RECEIVE: 'receive',
    APPROVAL: 'approval',
    TASKS: 'tasks',
    PHOTOS: 'photos',
    OTHER: 'other',
  },
  VALID_ACTIVITY_FILTER_DATE_RANGE_LABELS: {
    TODAY: 'today',
    DAYS_7: 'days-7',
    DAYS_30: 'days-30',
    DAYS_365: 'days-365',
    PROJECT_START: 'project-start',
    CUSTOM_DATE: 'custom-date',
  },
  UNSYNCED_RESOURCE_METHODS: {
    CREATE: 'create',
    UPDATE: 'update',
  },
  UNSYNCED_RESOURCE_UPDATE_OPERATIONS: {
    TASK_ADD_PF_FILES: 'taskAddPfFiles',
    TASK_REPLACE_PF_FILE_ID: 'taskReplacePfFileId',
    TASK_COMMENT_ADD_PF_FILES: 'taskCommentAddPfFiles',
    TASK_COMMENT_REPLACE_PF_FILE_ID: 'taskCommentReplacePfFileId',
    PHOTO_REPLACE_FILE: 'photoReplaceFile',
  },
  ACTIVITY_KEYS: {
    PATCH_TASK_COMMENT_MESSAGE: 'patchtaskcommentmessage',
    PATCH_TASK_COMMENT_FILES: 'patchtaskcommentfiles',
    POST_PARTICIPANT: 'postparticipant',
    POST_TASK_COMMENT: 'posttaskcomment',
    PUT_PROJECT_PARTICIPANT_PERMISSION: 'putprojectparticipantpermission',
    PUT_PROJECT_PARTICIPANT_ENABLED: 'putprojectparticipantenabled',
    GET_PLAN_REVISION_PDF: 'getplanrevisionpdf',
    GET_PLAN_REVISION_DWG: 'getplanrevisiondwg',
    GET_DOCUMENT_REVISION: 'getdocumentrevision',
    SEND_MIXED: 'sendmixed',
    GET_APPROVAL_COMMENT_ATTACHMENT: 'getapprovalcommentattachment',
    GET_DOCUMENT_APPROVAL_COMMENT_ATTACHMENT: 'getdocumentapprovalcommentattachment',
    PATCH_PLAN_TRASH: 'patchplantrash',
    PATCH_DOCUMENT_TRASH: 'patchdocumenttrash',
    PATCH_PLAN_REVISION_APPROVAL_DATE: 'patchplanrevisionapprovaldate',
    PATCH_DOCUMENT_REVISION_APPROVAL_DATE: 'patchdocumentrevisionapprovaldate',
    POST_PLAN_TAG: 'postplantag',
    POST_DOCUMENT_TAG: 'postdocumenttag',
    PUT_PLAN_NAME: 'putplanname',
    PUT_PLAN_PHASE: 'putplanphase',
    PATCH_PLAN_TOP_CATEGORY: 'patchplantopcategory',
    PATCH_PLAN_AUTHOR: 'patchplanauthor',
    PUT_DOCUMENT_NAME: 'putdocumentname',
    PUT_DOCUMENT_PHASE: 'putdocumentphase',
    PATCH_DOCUMENT_TOP_CATEGORY: 'patchdocumenttopcategory',
    PATCH_DOCUMENT_AUTHOR: 'patchdocumentauthor',
    PATCH_DOCUMENT_PERMISSION: 'patchdocumentpermission',
  },
  RESOURCE_NAMES: {
    TASK: 'task',
    TASK_COMMENT: 'task-comment',
    PHOTO: 'photo',
  },
  FILE_RESOLUTIONS: {
    THUMB: 'thumb',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
  },
  FILTER_KEYS: {
    TASKS_LIST_WEB_DRAFTS: 'tasksListWebDrafts',
    TASKS_LIST_WEB_MAIN: 'tasksListWebMain',
    TASKS_LIST_WEB_DONE: 'tasksListWebDone',
    TASKS_LIST_MOBILE_DRAFTS: 'tasksListMobileDrafts',
    TASKS_LIST_MOBILE_MAIN: 'tasksListMobileMain',
    TASKS_LIST_MOBILE_DONE: 'tasksListMobileDone',
    PLANS_LIST_WEB_MAIN: 'plansListWebMain',
    PLANS_LIST_MOBILE_MAIN: 'plansListMobileMain',
    DOCUMENTS_LIST_WEB_MAIN: 'documentsListWebMain',
    DOCUMENTS_LIST_MOBILE_MAIN: 'documentsListMobileMain',
    PHOTOS_LIST_WEB_MAIN: 'photosListWebMain',
    PHOTOS_LIST_MOBILE_MAIN: 'photosListMobileMain',
    PARTICIPANTS_LIST_WEB_MAIN: 'participantsListWebMain',
    PARTICIPANTS_LIST_MOBILE_MAIN: 'participantsListMobileMain',
    ACTIVITIES_LIST_WEB: 'activitiesListWeb',
    ACTIVITIES_LIST_MOBILE: 'activitiesListMobile',
  },
  FILTER_PROPERTIES: {
    PROJECTS_OWNERSHIP_ALL: 'projects-all',
    PROJECTS_OWNERSHIP_PARTICIPANT: 'projects-participant',
    PROJECTS_OWNERSHIP_OWNER: 'projects-owner',
  },
  REVISION_LOG_CATEGORIES: {
    TRASH: 'trash',
    EXPORT: 'exported',
    IMPORT: 'imported',
    TAG: 'tag',
    ITEM_ACTIVITY: 'itemActivity',
  },
  PARTICIPANT_PERMISSIONS: {
    SILENT: 'silent',
    PARTICIPANT: 'participant',
    ADMIN: 'admin',
    OWNER: 'owner',
  },
  PHOTO_LIST_STYLES: {
    GRID_LG: 'gridLg',
    GRID_SM: 'gridSm',
  },
  PHOTOS_LIST_GROUPING: {
    GROUP_BY_LOCATION_LAYER: 'location_layer',
    GROUP_BY_ALBUM: 'album',
    GROUP_BY_NONE: 'none',
  },
  SORT_PROPERTIES: {
    ITEM_NAME: 'item-name',
    ITEM_INDEX: 'item-index',
    ITEM_CONTENT: 'item-content',
    ITEM_PHASETAG: 'item-phasetag',
    ITEM_TAGS: 'item-tags',
    ITEM_FILES_PLAN_PRINT: 'item-print-file',
    ITEM_FILES_PLAN_CAD: 'item-cad-file',
    ITEM_FILE_DOCUMENT: 'item-document-file',
    ITEM_AUTHOR: 'item-author',
    ITEM_APPROVERS: 'item-approvers',
    ITEM_REVISION_CREATED: 'item-last-upload',
    ITEM_LAST_APPROVAL_DATE: 'item-last-approval-date',
    ITEM_SELECTED: 'item-selected',
    ITEM_TOP_CATEGORY: 'item-top-category',
    ITEM_APPROVAL_DATE: 'item-approval-date',
    TASK_TITLE: 'task-title',
    TASK_TYPE: 'task-type',
    TASK_CREATED: 'task-created',
    TASK_PUBLISHED: 'task-published',
    TASK_DUE_DATE: 'task-due-date',
    TASK_NEWEST: 'task-newest',
    TASK_MODIFIED: 'task-modified',
    TASK_STATE: 'task-state',
    TASK_ASSIGNEE: 'task-assignee',
    TASK_CREATOR: 'task-creator',
    TASK_LOCATION: 'task-location',
    TASK_CONSECUTIVE_NUMBER: 'task-consecutive-number',
    TASK_FILES: 'task-files',
    TASK_SELECTED: 'task-selected',
    PHOTO_NEWEST: 'photo-newest',
    PHOTO_OLDEST: 'photo-oldest',
    PHOTO_MODIFIED: 'photo-modified',
    PHOTO_SELECTED: 'photo-selected',
    PARTICIPANT_EMAIL: 'participant-email',
    PARTICIPANT_NAME: 'participant-name',
    PARTICIPANT_ROLE: 'participant-role',
    PARTICIPANT_PHONE: 'participant-phone',
    PARTICIPANT_COMPANY: 'participant-company',
    PARTICIPANT_PERMISSION: 'permission-status',
    PARTICIPANT_CAN_APPROVE_REVISIONS: 'permission-approval',
    PARTICIPANT_UPLOAD_ALERT: 'permission-upload-alert',
    PARTICIPANT_SELECTED: 'participant-selected',
    CLIPBOARD_FILE_NAME: 'clipboard-file-name',
    CLIPBOARD_FILE_TYPE: 'clipboard-file-type',
    CLIPBOARD_FILE_STATUS: 'clipboard-file-status',
    PROJECT_TITLE_ASC: 'project-title-asc',
    PROJECT_TITLE_DESC: 'project-title-desc',
    PROJECT_LASTREVISIONUPLOAD: 'project-lastrevisionupload',
    PROJECT_CREATED_AT: 'project-created-at',
  },

  FUNCTIONAL_CSS_CLASS: {
    DRAG_HANDLE: 'js-drag-handle',
    DRAG_HANDLE_DISABLED: 'js-drag-handle-disabled',
    MAP_PINS_JIGGLE_ANIMATION: 'js-pin-jiggle-animation',
  },

  LOCALES: {
    DE: 'de',
    EN: 'en',
    EN_GB: 'en-gb',
    EN_US: 'en-us',
  },

  ITEM_TYPES: {
    PLANS: 'plans',
    DOCUMENTS: 'documents',
    PARTICIPANTS: 'participants',
    TASKS: 'tasks',
    PHOTOS: 'photos',
    ACTIVITIES: 'activities',
  },

  ITEM_PRINT_MODES: {
    OVERVIEW: 'overview',
    DETAIL: 'detail',
  },

  // Photo detail-print image quality. Maps server-side to a pre-generated file
  // resolution variant in sharing/photos/print/GET.js (LOW → SMALL, MEDIUM →
  // MEDIUM, HIGH → LARGE).
  PHOTO_PRINT_DETAIL_IMAGE_QUALITY: {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
  },

  // Above this many selected photos the async PDF generation is disabled — the
  // render would be too large/slow. Browser print (via the iframe) stays available.
  PHOTO_PRINT_PDF_MAX_PHOTOS: 500,

  APPROVAL_STATUS: {
    APPROVED: 'approved',
    APPROVED_VIA_IMPORT: 'approvedViaImport',
    REJECTED: 'rejected',
    PENDING: 'pending',
    NOTREQUESTED: 'notrequested',
  },

  APPROVAL_MODE: {
    AND: 'and',
    OR: 'or',
  },

  APPROVER_STATUS: {
    APPROVED: 'approved',
    REJECTED: 'rejected',
    PENDING: 'pending',
    OBSOLETE: 'obsolete',
    CANCELLED: 'cancelled',
  },

  // Raw persisted emaillog.processingStatus. Mirrors server/config/constants.js, which is what the
  // emaillogs model enum reads — the server never imports client-shared, so both copies must stay in sync.
  EMAILLOG_PROCESSING_STATUS: {
    TRIGGERED_SEND: 'triggeredSend',
    LEGACY_DONE: 'legacyDone',
    POST_MARK_FAILED: 'postMarkFailed',
    POST_MARK_DONE: 'postMarkDone',
  },

  // Derived per-recipient UI status, computed in get-mail-recipient-delivery-status.js (not persisted).
  MAIL_RECIPIENT_DELIVERY_STATUS: {
    DOWNLOADED: 'downloaded',
    BOUNCED: 'bounced',
    DELIVERED: 'delivered',
    PROCESSING: 'processing',
    UNKNOWN: 'unknown',
    SEND_FAILED: 'sendFailed',
  },

  // Persisted on participant.invitationEmailStatus.processStatus; 'unknown' is never stored, derived at read-time.
  // Values must stay string-identical to their MAIL_RECIPIENT_DELIVERY_STATUS twins — a divergence breaks the banner silently.
  INVITATION_EMAIL_PROCESS_STATUS: {
    PROCESSING: 'processing',
    DELIVERED: 'delivered',
    BOUNCED: 'bounced',
    SEND_FAILED: 'sendFailed',
  },

  MAP_STATES: {
    VIEW: 'VIEW',
    ADD_PINS: 'ADD_PINS',
    EDIT_PINS: 'EDIT_PINS',
    NEW_PIN_SELECTED: 'NEW_PIN_SELECTED',
    EXISTING_PIN_SELECTED: 'EXISTING_PIN_SELECTED',
  },

  VIEW_QUERY_PARAMS: {
    MAP: 'map',
  },

  TASK_COMMENT_NEW_MODAL_ACTIONS: {
    COMMENT_NEW: 'comment_new',
    QUESTION_NEW: 'question_new',
    QUESTION_ADD_QUESTION: 'question_add_question',
    QUESTION_REOPEN: 'question_reopen',
    QUESTION_ANSWER_QUESTION: 'question_answer_question',
    COMMENT_DONE: 'comment_done',
    COMMENT_REOPEN: 'comment_reopen',
    DONE: 'done',
    STATE_CHANGE_TO_EXECUTION: 'state_change_to_execution',
    STATE_CHANGE_TO_QUESTION: 'state_change_to_question',
    STATE_CHANGE_TO_DONE: 'state_change_to_done',
  },

  TASK_TEXT_SEARCH_HIT_WORD_OFFSET: 5,

  BREAKPOINTS: {
    MOBILE: 768,
  },

  CHECKBOX_STATES: {
    UNSELECTED: 'unselected',
    PARTIALLY_SELECTED: 'partially-selected',
    FULLY_SELECTED: 'fully-selected',
    AUTO_GRANTED: 'auto-granted',
  },

  TEXT_BLOCK_CATEGORIES: {
    DOCUMENT_SEND: 'document-send',
    DOCUMENT_REVISION: 'document-revision',
    PLAN_SEND: 'plan-send',
    PLAN_REVISION: 'plan-revision',
    PLAN_APPROVAL_REQUEST: 'plan-approval-request',
    PLAN_APPROVAL: 'plan-approval',
    DOCUMENT_APPROVAL_REQUEST: 'document-approval-request',
    DOCUMENT_APPROVAL: 'document-approval',
    INVITE_PARTICIPANT: 'invite-participant',
    TASK_NEW_COMMENT: 'task-new-comment',
    TASK_SEND: 'task-send',
    TASK_DESCRIPTION: 'task-description',
    PHOTO_DESCRIPTION: 'photo-description',
    MIXED_SEND: 'mixed-send',
  },
  PARTICIPANT_IMPORT_SOURCES: {
    VCF: 'vcf',
    PROJECT: 'project',
    DEVICE: 'device',
  },
  SANITIZE_ALLOWED_TAGS: {
    DEFAULT: [
      'span',
      'ul',
      'li',
      'strong',
      'ol',
      'italic',
      'i',
      'b',
      'u',
      'br',
      'div',
      'p',
      'a',
    ],
    RICH_TEXT_WITH_IMAGES: [
      'span',
      'ul',
      'li',
      'strong',
      'ol',
      'italic',
      'i',
      'b',
      'u',
      'br',
      'div',
      'p',
      'img',
      'figure',
      'a',
    ],
  },
}
